import './CookieBanner.scss'

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Close from 'icons/Close'
import ChevronRight from 'icons/ChevronRight'
import { getCookie, setPersistantCookie } from 'lib/util/cookie'

const { COOKIE_NOTICE_COOKIE_NAME } = process.env

function setCookie() {
  return setPersistantCookie(COOKIE_NOTICE_COOKIE_NAME, true.toString())
}

function setLocalStorage() {
  return localStorage.setItem(COOKIE_NOTICE_COOKIE_NAME, true.toString())
}

function getStoredValue(): boolean {
  return localStorage.getItem(COOKIE_NOTICE_COOKIE_NAME) === 'true' || getCookie(COOKIE_NOTICE_COOKIE_NAME) === 'true'
}

export default function CookieBanner() {
  const [t] = useTranslation()
  const [shouldHide, setShouldHide] = useState(getStoredValue())

  const dismiss = () => {
    setCookie()
    setLocalStorage()
    setShouldHide(true)
  }

  if (shouldHide) {
    setLocalStorage()
    return null
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-banner__text">
        {t('banners.cookie.text')}{' '}
        <a className="cookie-banner__link" href={`${process.env.WWW_URI}/privacy`}>
          {t('banners.cookie.link')}{' '}
          <span className="cookie-banner__chevron">
            <ChevronRight />
          </span>
        </a>
      </div>
      <div className="cookie-banner__close" onClick={dismiss}>
        <span className="cookie-banner__close-chevron">
          <Close />
        </span>
      </div>
    </div>
  )
}
